import { createHistory } from 'history';
import { useRouterHistory } from 'react-router';

const historyConfig = { basename: '' };
const history = useRouterHistory(createHistory)(historyConfig);

module.exports = history;



// WEBPACK FOOTER //
// ./frontend/a2i/js/store/history.js